"use strict";
/* tslint:disable */
var TRegularLineType = Object.assign({}, TBaseLineType, {
    buildView: function (selection, mode, context) {
        if (Selections.isHidden(selection)) {
            return '';
        }
        // adds "same_event" and "show_odds_msg" classes - Monov
        var wrapperClasses = Selections.getWrapperClasses(mode, selection);
        var selectionType = BetSlipUtil.getSelectionType(selection);
        var __html = '';
        if (mode.isFirstSelection) {
            __html += mode.buildHeader();
        }
        mode.isFirstSelection = false;
        var __html = `
            <div id="sce_${selection.ViewKey}" class="idBetsItem ${wrapperClasses} ${selectionType}" data-uat="bet-selection">
                ${this.buildInnerView(selection, mode, context, selectionType)}
            </div>
        `;
        return __html;
    },
    buildInnerView: function (selection, mode, context, selectionType) {
        var lineType = BetSlipUtil.getLineType();
        var selectionType = selectionType || BetSlipUtil.getSelectionType(selection);
        return `
            <div class="betSlip_row_wrapper ${lineType}" data-gesture="pan">
                ${this.buildRowWrapperContent(selection, mode, context, lineType, selectionType)}
            </div>
            ${TSlipShared.createInlineMessage(mode, selection, context)}
        `;
    },
    defaultLine: function (selection, selectionType, mode, context) {
        return `
            <div class="betSlip_row_content">
                <div>
                    ${TSelections[selectionType].buildPick(mode, selection, context)}
                    ${TSlipShared.createPickLineOdds(mode, selection, context)}
                </div>
                <div>
                    <div class="betSlip_row_desc">
                        ${TSelections[selectionType].buildDescription(mode, selection, context)}
                        ${TMinMax.createMinMaxForSingleSlipMode(mode, selection)}
                        ${this.createEachwayBox.defaultLine(selection, mode, context)}
                    </div>
                </div>
            </div>
            <div class="betSlip_row_stake">
                <div class="stakeOptions">
                    ${TSlipShared.createBuyPointsSelect(selection)}
                    ${TSlipShared.createMultiSelectionBox(mode, selection)}
                    ${TSlipShared.createSingleStakeBox(mode, selection)}
                    ${TSlipShared.createCombinatorGroupSelect(mode, selection)}
                    ${TSlipShared.createMaxBet(selection, mode)}
                </div>
            </div>
        `;
    },
    UKLine: function (selection, selectionType, mode, context) {
        var toReturnValue = mode.getSingleReturn(selection.ViewKey) || '';
        var __html = '';
        __html += `
            <div class="betSlip_row_content">
                <div>
                    <div class="betSlipCheckbox betSlipCheckbox--multiSelection">
                        ${TSlipShared.createMultiSelectionBox(mode, selection)}
                    </div>
                    ${TSelections[selectionType].buildPick(mode, selection, context)}
                    ${TSlipShared.createPickLineOdds(mode, selection, context)}
                </div>
                <div>
                    <div class="betSlip_row_desc">
                        ${TSelections[selectionType].buildDescription(mode, selection, context)}
                        ${TMinMax.createMinMaxForSingleSlipMode(mode, selection)}
                    </div>
                </div>
            </div>
            <div class="betslipStakeLine">
                ${TSlipShared.createBuyPointsSelect(selection)}
                <div class="betslipStakeLine__return returnBox">
                    <span class="returnBox__head">${$string("BettingHistory").Return}</span>
                    <span class="returnBox__value" id="single_return_value_${selection.ViewKey}" data-uat="bet-slip-total-return-value">${toReturnValue}</span>
                </div>
                <div class="betslipStakeLine__stake">
                    <div class="betslipStakeLine__stakeInner clearfix">
                        ${this.createEachwayBox.UKLine(selection, mode, context)}
                        ${TSlipShared.createSingleStakeBox(mode, selection)}
                        ${TSlipShared.createUKMaxBet(selection, mode)}
                    </div>
                </div>`;
        if (selection.EachWaySingleIncluded || selection.EachWayMultiplesIncluded) {
            __html += `
                    <div class="betSlipEachWay" data-uat="bet-slip-each-way">
                        <strong class="betSlipEachWay__title" data-uat="bet-slip-each-way-label">
                            <small>${Selections.getEachWayString(selection)}</small>
                        </strong>
                    </div>`;
        }
        __html += `
            </div>`;
        return __html;
    },
    editModeLine: function (selection, selectionType, mode, context) {
        return `
            <div class="betSlip_row_content edit-mybets-line">
                <span class="edit-mybets-message">
                    ${selection.BetID ? $dict.bs("ExistingSelection") : $dict.bs("NewSelection")}
                </span>
                <div>
                    ${TSelections[selectionType].buildPick(mode, selection, context)}
                    ${TSlipShared.createPickLineOdds(mode, selection, context)}
                </div>
                <div>
                    <div class="betSlip_row_desc">
                        ${TSelections[selectionType].buildDescription(mode, selection, context)}
                        ${TMinMax.createMinMaxForSingleSlipMode(mode, selection)}
                    </div>
                </div>
            </div>
        `;
    }
});
window.TRegularLineType = TRegularLineType;
//# sourceMappingURL=TRegularLineType.js.map